import { Component, OnInit } from '@angular/core';
import {RegisterFormService} from '../shared/services/registerFormService/register-form.service';
import {Router} from '@angular/router';
import {PayService} from '../shared/services/payService/pay.service';
import {Form} from '../shared/classes/Form';
import {PayInfo} from '../shared/classes/PayInfo';

@Component({
  selector: 'app-cash-info',
  templateUrl: './cash-info.component.html',
  styleUrls: ['./cash-info.component.css']
})
export class CashInfoComponent implements OnInit {

  form: Form = undefined;
  payInfo: PayInfo = undefined;

  constructor(private registerFormService: RegisterFormService,
              private router: Router,
              private payService: PayService) { }

  ngOnInit() {
    this.form = this.registerFormService.form;
    this.payInfo = this.payService.payInfo;
  }

  continue(){
    this.router.navigate(['/showForm', this.payService.returnFormId]);
    this.registerFormService.regForm = undefined;
  }

}
